import { BrowserModule } from '@angular/platform-browser';
import { NgModule,NO_ERRORS_SCHEMA,CUSTOM_ELEMENTS_SCHEMA  } from '@angular/core';

import { HttpModule } from '@angular/http';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import{ ReactiveFormsModule, FormsModule } from '@angular/forms'
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';

  import { AppSettings } from './services/constants/constants';
import { MessageService } from 'primeng/api';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { DialogModule } from 'primeng/dialog';
//Additional 
//Model
import { NgbModule,NgbDate, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
//progress bar
import{ NgProgressModule } from '@ngx-progressbar/core'
import { NgProgressHttpModule } from '@ngx-progressbar/http';
import { NgProgressRouterModule } from '@ngx-progressbar/router';
//Toast Service
import { ToastrModule } from 'ngx-toastr';
//Select drop down
import { NgSelectModule } from '@ng-select/ng-select';

//Date Pikker
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import {  TimepickerModule } from 'ngx-bootstrap/timepicker';

//Sidebar
import { SidebarModule } from 'ng-sidebar';

//Session
import { BnNgIdleService } from 'bn-ng-idle';


import {AutocompleteLibModule} from 'angular-ng-autocomplete';

// import { AngularMaterialModule } from './angular-material.module';

import { IConfig, NgxMaskModule } from 'ngx-mask'

import { NgxPaginationModule } from 'ngx-pagination'; 

import { Ng2SearchPipeModule } from 'ng2-search-filter';

//Component
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';


// service
import { DhukanDataService } from './services/dhukan/dhukan-data.service';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { ConfirmationDialogService } from './components/confirmation-dialog/confirmation-dialog.service';


import { TwoDigitDecimaNumberDirectiveDirective } from './two-digit-decima-number-directive.directive';

import { DateFormatPipe } from './date-format.pipe';
import { DatePipe, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { DatetimeFormatPipe } from './datetime-format.pipe';
import { LoadingComponent } from './components/loading/loading.component';
import { DisablecontrolDirective } from './disablecontrol.directive';
import { HttpcancelService } from './services/dhukan/httpcancel.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ManageHttpInterceptor } from './interceptor/managehttp.interceptor';
import { ProcessComponent } from './components/process/process.component';
import { environment } from 'src/environments/environment';
import { PendingChangesGuard } from './components/PendingChangesGuard';
import { NgMaskCusDirectiveDirective } from './ng_mask_cus-directive.directive';
import { NgOtpInputModule } from 'ng-otp-input';
import { SortDirective } from './sort.directive';
import { HomeComponent } from './components/home/home.component';
import { ProductdetailsComponent } from './components/productdetails/productdetails.component';
import { SplashComponent } from './components/splash/splash.component';
import { MenuComponent } from './components/menu/menu.component';
import { BilldetailsComponent } from './ebillcomponents/billdetails/billdetails.component';
import { FeedbackComponent } from './feedbackcomponents/feedback/feedback.component';
import { QrsplashComponent } from './scanordercomponents/qrsplash/qrsplash.component';
import { QrhomeComponent } from './scanordercomponents/qrhome/qrhome.component';
import { QrmenuComponent } from './scanordercomponents/qrmenu/qrmenu.component';
import { DemohomeComponent } from './demo/demohome/demohome.component';
import { DemomenuComponent } from './demo/demomenu/demomenu.component';
import { DemosplashComponent } from './demo/demosplash/demosplash.component';
import { ProductsearchComponent } from './components/productsearch/productsearch.component';
import { SearchPipe } from './search.pipe';
import { CartsliderComponent } from './scanordercomponents/cartslider/cartslider.component';
import { CustomerinfoComponent } from './scanordercomponents/customerinfo/customerinfo.component';
import { UseraccessComponent } from './useraccess/useraccess.component';
import { RequestComponent } from './scanordercomponents/request/request.component';
import { OrderstatusComponent } from './scanordercomponents/orderstatus/orderstatus.component';
import { QrproductdetailsComponent } from './scanordercomponents/qrproductdetails/qrproductdetails.component';
import { LoginComponent } from './scanordercomponents/login/login.component';
import { OrdersComponent } from './scanordercomponents/orders/orders.component';
import { OrdersdetailsComponent } from './scanordercomponents/ordersdetails/ordersdetails.component';
import { GroupbyPipe } from './groupby.pipe';
import { ProfileqrComponent } from './components/profileqr/profileqr.component';
import { LoyallofeedbackComponent } from './components/loyallofeedback/loyallofeedback.component';
import { ColorPickerModule } from 'primeng/colorpicker';
import { CsprofileqrComponent } from './components/csprofileqr/csprofileqr.component';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

export const customCurrencyMaskConfig = {
  align: "right",
  allowNegative: true,
  allowZero: true,
  decimal: ".",
  precision: 2,
  prefix: "R$ ",
  suffix: "",
  thousands: ".",
  nullable: true
};



const maskConfig: Partial<IConfig> = {
  validation: false,
  thousandSeparator: "",
  separatorLimit: "9999999999",
  allowNegativeNumbers: true,
  dropSpecialCharacters:false,
  patterns:{
    'V': {pattern: new RegExp('-?')},
    '0': {pattern: new RegExp('[0-9]')}
  }
};

@NgModule({
  declarations: [
    AppComponent,
    ConfirmationDialogComponent,
    TwoDigitDecimaNumberDirectiveDirective, 
    NgMaskCusDirectiveDirective,    
    DateFormatPipe,    
    DatetimeFormatPipe,    
    LoadingComponent,    
    DisablecontrolDirective,    
    ProcessComponent,     
    SortDirective,
    HomeComponent,
    ProductdetailsComponent,
    SplashComponent,
    MenuComponent,
    BilldetailsComponent,
    FeedbackComponent,
    QrsplashComponent,
    QrhomeComponent,
    QrmenuComponent,
    DemohomeComponent,
    DemomenuComponent,
    DemosplashComponent,
    ProductsearchComponent,
    SearchPipe,
    CartsliderComponent,
    CustomerinfoComponent,
    UseraccessComponent,
    RequestComponent,
    OrderstatusComponent,
    QrproductdetailsComponent,
    LoginComponent,
    OrdersComponent,
    OrdersdetailsComponent,
    GroupbyPipe,
    ProfileqrComponent,
    LoyallofeedbackComponent,
    CsprofileqrComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpModule,
    HttpClientModule,
    BrowserAnimationsModule,
    FormsModule,  
    ReactiveFormsModule,
    NgbModule,
    NgProgressModule,
    NgProgressHttpModule,
    NgProgressRouterModule,
    NgSelectModule,  
    NgOtpInputModule,
     DialogModule,
    DynamicDialogModule,
    
    BsDatepickerModule.forRoot(),
    TimepickerModule.forRoot(),
    SidebarModule.forRoot(),  
    NgxMaskModule.forRoot(maskConfig),
    ToastrModule.forRoot({
      timeOut: 500,
      positionClass: 'toast-top-center',
      titleClass:'titleClass'
    }),
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
      }
    }), 
    NgxPaginationModule,
    Ng2SearchPipeModule, 
    AutocompleteLibModule,    
  ],
  schemas:[NO_ERRORS_SCHEMA,CUSTOM_ELEMENTS_SCHEMA],
  providers: [DatePipe,DateFormatPipe, Location, PendingChangesGuard, { provide: LocationStrategy, useClass: PathLocationStrategy },   
    { provide:HTTP_INTERCEPTORS, useClass:ManageHttpInterceptor,multi:true},],
  bootstrap: [AppComponent],
  exports: [BrowserModule, TranslateModule,BsDatepickerModule],
  entryComponents: [ ConfirmationDialogComponent,ProductdetailsComponent,ProductsearchComponent,CartsliderComponent],
})
  
export class AppModule {
  constructor() {
    if (localStorage.session === undefined || localStorage.session === '' || localStorage.session === null) {
        this.randomkey = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
        localStorage.setItem('session', this.randomkey)
    }

  
  }
    randomkey;
 }

